/**
 * VENTISETTE — Kategorie-Navigation
 *
 * Trägt nur das Drawer-Verhalten unter 990px. Auf dem Desktop ist die
 * Navigation statisches Markup und braucht kein Skript: der aktive Zustand
 * kommt aus Liquid, das Aufklappen aus CSS.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 989px)';

  function init() {
    var nav = document.querySelector('[data-ven-catnav]');
    var trigger = document.querySelector('[data-ven-catnav-open]');
    var scrim = document.querySelector('[data-ven-catnav-scrim]');
    if (!nav || !trigger || !scrim) return;

    var closeBtn = nav.querySelector('[data-ven-catnav-close]');
    var lastFocused = null;

    function focusable() {
      return Array.prototype.slice.call(nav.querySelectorAll('a[href], button:not([disabled])')).filter(
        function (el) {
          return el.tabIndex !== -1;
        }
      );
    }

    function open() {
      lastFocused = document.activeElement;
      scrim.hidden = false;

      // Erzwungener Reflow, bevor der offene Zustand gesetzt wird: sonst
      // fasst der Browser Einblenden und Zustandswechsel zu einem Schritt
      // zusammen und der Übergang entfällt. Bewusst kein requestAnimationFrame
      // — das feuert in Hintergrund-Tabs nicht, der Drawer bliebe dann hängen.
      void scrim.offsetWidth;

      nav.setAttribute('data-open', 'true');
      scrim.setAttribute('data-open', 'true');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);

      var target = closeBtn || focusable()[0];
      if (target) target.focus();
    }

    function close() {
      nav.removeAttribute('data-open');
      scrim.removeAttribute('data-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);

      // Der Scrim bleibt bis zum Ende des Übergangs im Baum, sonst springt er weg.
      var done = function () {
        if (!nav.hasAttribute('data-open')) scrim.hidden = true;
        scrim.removeEventListener('transitionend', done);
      };
      scrim.addEventListener('transitionend', done);
      window.setTimeout(done, 600);

      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;

      var items = focusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    trigger.addEventListener('click', open);
    scrim.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Beim Wechsel auf Desktop den Drawer-Zustand vollständig zurücknehmen,
    // sonst bliebe body.overflow gesperrt.
    window.matchMedia(MOBILE).addEventListener('change', function (event) {
      if (!event.matches && nav.hasAttribute('data-open')) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
